/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Name_LabelInputs */

const en_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Name`)
};

const fr_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du locuteur`)
};

const de_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name des Sprechers`)
};

const it_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome dell'oratore`)
};

const ru_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя докладчика`)
};

const es_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del orador`)
};

const zh_cn2_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者姓名`)
};

const ja_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者名`)
};

const hi_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता का नाम`)
};

const pt_pt2_speaker_manager_name_label = /** @type {(inputs: Speaker_Manager_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do palestrante`)
};

/**
* | output |
* | --- |
* | "Speaker Name" |
*
* @param {Speaker_Manager_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_name_label = /** @type {((inputs?: Speaker_Manager_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_name_label(inputs)
	if (locale === "de") return de_speaker_manager_name_label(inputs)
	if (locale === "it") return it_speaker_manager_name_label(inputs)
	if (locale === "ru") return ru_speaker_manager_name_label(inputs)
	if (locale === "es") return es_speaker_manager_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_name_label(inputs)
	if (locale === "ja") return ja_speaker_manager_name_label(inputs)
	if (locale === "hi") return hi_speaker_manager_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_name_label(inputs)
	return en_speaker_manager_name_label(inputs)
});